import { ICategoryComboActions } from "../../action-types/category/ICategoryComboActionType";
import { ICategoryComboReducer } from "../../reducer-model/category/ICategoryComboReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ICategoryComboReducer = {
    status: eReducerStatusBase.is_not_initialization,
    categoryCombos: []
}
export const categoryComboReducer = (state: ICategoryComboReducer = iniState, action: ICategoryComboActions): ICategoryComboReducer => {
    switch (action.type) {
        case "CATEGORY_COMBO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "CATEGORY_COMBO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                categoryCombos: action.payload
            }
        case "CATEGORY_COMBO_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CATEGORY_COMBO_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                categoryComboEditing: action.payload
            }
        case "CATEGORY_COMBO_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CATEGORY_COMBO_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "CATEGORY_COMBO_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "CATEGORY_COMBO_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CATEGORY_COMBO_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "CATEGORY_COMBO_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "CATEGORY_COMBO_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}

